(ns frontend.ui.component.lp-portal.report.body.sparkmind.holding.web
  (:require
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.component.block-table.view :as block-table]
   [frontend.ui.component.lp-portal.report.component.vertical-table.view :as vertical-table]
   [frontend.ui.component.lp-portal.voima-components.badge.view :as badge]
   [frontend.ui.component.lp-portal.voima-components.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.free-text-card.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.voima-components.section.style :as style]
   [frontend.ui.component.lp-portal.voima-components.section.view :as section]
   [frontend.ui.style.theme.core :as theme]
   [herb.core :refer [<class]]
   [frontend.ui.component.table.view :as table]))

(defn overview-card
  [{:keys [case-overview general-information]}
   props]
  (let [block-table-config {:background-color (theme/color [:content-card :child :secondary :bg])
                            :border?          false
                            :hide-footnote?   true}]
    [card/card
     {:title ""
      :background-color (theme/color [:content-card :child :secondary :bg])}
     [:div
      [free-text-card/free-text-section "" case-overview props]]
     [:div
      [table/editable-table general-information (merge props block-table-config)
       [block-table/table "" general-information (merge props block-table-config)]]]]))

(defn company-section
  [ui-data props]
  (let [{:keys [holding-name overview business-and-general-kpi current-key-impact-indicators]} ui-data]
    [section/portfolio-section
     [:div
      [:div
       {:style {:display     :flex
                :justify-content :space-between
                :align-items :flex-end
                :gap         :16px}}
       [:div
        {:style {:display   :inline-flex
                 :max-width :200px}}
        [:div {:class (<class style/holding-header)} holding-name]]
       [:div
        {:style {:padding-top :16px}}
        [badge/badge
         {:variant :portfolio-company
          :pill?   false}
         "Portfolio company"]]]]

     (str "company-section-"
          (some->> props
                   :report
                   :db/id))
     [:div {:class (<class style/section-wrapper)}
      [overview-card overview props]
      [:div
       {:style {:margin-top "8px"}}
       [grid/row {}
        [grid/column {:large 6}
         [table/editable-table business-and-general-kpi props
          [vertical-table/table "" business-and-general-kpi props]]]
        [grid/column {:large 6}
         [table/editable-table current-key-impact-indicators props
          [vertical-table/table "" current-key-impact-indicators props]]]]]]]))

(defn view
  [{:keys [holding-ui-data] :as props}]
  [:div
   {:id (str "holding-report-" (:report-id holding-ui-data))}
   [:div
    [company-section holding-ui-data props]]])

